var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 18h24V0H0v18zM2.482 2h19.035L12 9.713 2.482 2zM22 4.183V16H2V4.183l10 8.104 10-8.104z","fillRule":"evenodd"}));
}

Mail.defaultProps = {"width":"24","height":"18","viewBox":"0 0 24 18"};

module.exports = Mail;

Mail.default = Mail;
